import React from "react";
import {
  Box,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { IPriceItinerary, ISize } from "../interfaces.lowPrice";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { ReturnDate } from "./ReturnDate";
import { differenceInDays } from "date-fns";
import { getCellStyles } from "../sharedStyles";
import { useTranslations } from "hooks/useTranslations";

interface IProps {
  size: ISize;
  cheapestCombinations: IPriceItinerary[];
  height: number;
  transformY: number;
  selectedItineraryDates: { departureDate: string; returnDate: string } | null;

  handleTransformY: (number: number) => void;
}

export const ReturnNavigation = (props: IProps) => {
  const {
    size,
    cheapestCombinations,
    height,
    transformY,
    selectedItineraryDates,

    handleTransformY = () => {},
  } = props;

  const t = useTheme();
  const { lowPriceCalendar } = useTranslations().translations;

  const isMobile = useMediaQuery(t.breakpoints.down("md"));
  const listOfReturnDates = cheapestCombinations.filter(
    (o) => o.departureDate === cheapestCombinations[0].departureDate,
  );

  const getDisabledBefore = () => {
    const itn = listOfReturnDates.find(
      (elm: IPriceItinerary) => elm.returnDateDifference === transformY,
    );

    const today: Date = new Date();
    const diff = differenceInDays(new Date(itn?.returnDate as string), today);
    return diff < 2;
  };

  return (
    <Box
      sx={{
        display: "flex",
        height: `calc(100% - ${t.spacing(size.date + size.nav)}) `,
        width: t.spacing(size.returnDate + size.nav),
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box
        className="departure-date-list"
        sx={{
          position: "absolute",
          overflow: "visible",
          height: "100%",
          transform: `translateY(${-transformY * height}%)`,
          transition: `transform 250ms 50ms ease-in-out`,
        }}
      >
        {listOfReturnDates.map((obj: IPriceItinerary) => {
          if (
            obj.returnDateDifference < transformY + 4 &&
            obj.returnDateDifference > transformY - 4
          ) {
            return (
              <Box
                key={
                  "returnDates" +
                  obj.departureDateDifference +
                  "-" +
                  obj.returnDateDifference
                }
              >
                <ReturnDate
                  height={height}
                  width={size.returnDate}
                  priceItinerary={obj}
                  sxProps={getCellStyles(
                    false,
                    size.returnDate,
                    obj.departureDate === selectedItineraryDates?.departureDate,
                    obj.returnDate === selectedItineraryDates?.returnDate,
                    true,
                  )}
                />
              </Box>
            );
          }
        })}
      </Box>

      <Box
        className="return-navigation"
        sx={{
          display: "flex",
          bgcolor: t.palette.grey[100],
          height: "100%",
          ml: "auto",
          width: t.spacing(size.nav),
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <IconButton
          onClick={() => handleTransformY(-1)}
          size="small"
          disabled={getDisabledBefore()}
        >
          <KeyboardArrowUpIcon fontSize={isMobile ? "small" : "medium"} />
        </IconButton>
        <Typography
          variant={isMobile ? "bodySmall" : "h5"}
          sx={{
            my: 1,
            textOrientation: "mixed",
            writingMode: "vertical-lr",
            color: t.palette.grey[600],
          }}
        >
          {lowPriceCalendar.return}
        </Typography>
        <IconButton onClick={() => handleTransformY(1)} size="small">
          <KeyboardArrowDownIcon fontSize={isMobile ? "small" : "medium"} />
        </IconButton>
      </Box>
    </Box>
  );
};
